import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

export default function remove(
    action: RemoveTrackAction,
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>
) {
    const data = (Array.isArray(action.data) ? action.data : [action.data]).map((track) => ({
        ...track,
        properties: {...track.properties, archived: true},
        // Archive locally created unsaved waypoints
        ...(track.isGeometryLoaded
            ? {
                  points: mapValues(track.points, (point) => {
                      if (point.properties.isLocallyCreated && !point.properties.id) {
                          return {
                              ...point,
                              properties: {
                                  ...point.properties,
                                  archived: true,
                              },
                          };
                      }
                      return point;
                  }),
              }
            : undefined),
    }));

    setTracks((latestTracks) => ({
        ...latestTracks,
        ...keyBy(data, (track) => track.properties.localId),
    }));

    return data.map((track) => track.properties.localId);
}
